<template>
  <div class="ele-body">
    <el-card shadow="never">
      <ele-data-table ref="table" :config="table" height="calc(100vh - 261px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="ruleType" label="发送方式" align="center" sortable="custom" show-overflow-tooltip width="110">
            <template #default="{ row }">{{
              row.ruleType == 1 ? '按工作组' : row.ruleType == 2 ? '按教师' : row.ruleType == 3 ? '按学生' : ''
            }}</template>
          </el-table-column>
          <el-table-column prop="detail" label="短信内容" align="center" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="receiveType" label="接受对象" align="center" sortable="custom" show-overflow-tooltip width="110">
            <template #default="{ row }">
              {{ row.receiveType == 1 ? '教师' : row.receiveType == 2 ? '家长' : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="sendState" label="发送状态" align="center" sortable="custom" show-overflow-tooltip width="110">
            <template #default="{ row }">
              <el-tag :type="row.sendState == 1 ? '' : row.sendState == 2 ? 'success' : ''">
                {{ row.sendState == 1 ? '处理中' : row.sendState == 2 ? '已处理' : '' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" sortable="custom" show-overflow-tooltip width="200" />
          <el-table-column label="操作" width="230px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-popconfirm title="确定要删除此定时短信吗？" @onConfirm="removeSMS(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
  import { delTimingMessage } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        table: {
          // 成绩表格配置
          url: '/school/schoolMessage/getTimingMessageList',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            // res.data = res.data.records;
            return res;
          },
        },
      };
    },
    methods: {
      removeSMS(row) {
        let data = new FormData();
        data.append('id', row.id);
        delTimingMessage(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
